const state = {
    g_cities: [],
    g_company_types: [],
    g_company_categories: [],
    g_active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
    g_groups: [],
};

const getters = {

    getGActiveStates(state){
        return state.g_active_states;
    },
    getGCities(state){
        return state.g_cities;
    },
    getGCompanyTypes(state){
        return state.g_company_types;
    },
    getGCompanyCategories(state){
        return state.g_company_categories;
    },
    getGGroups(state){
        return state.g_groups;
    }
};

const mutations = {
    setGCities(state, payload){
        state.g_cities = payload;
    },
    setGCompanyTypes(state, payload){
        state.g_company_types = payload;
    },
    setGCompanyCategories(state, payload){
        state.g_company_categories = payload;
    },
    setGGroups(state, payload) {
        state.g_groups = payload
    }
};

const actions = {
    setGCities({commit}, payload){
        commit('setGCities', payload);
    },
    setGCompanyTypes({commit}, payload){
        commit('setGCompanyTypes', payload);
    },
    setGCompanyCategories({commit}, payload){
        commit('setGCompanyCategories', payload);
    },
    setGGroups({commit}, payload){
        commit('setGGroups', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

